const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* כותרת ראשית */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#9a624b] via-[#ac609c] to-[#9a624b] bg-clip-text text-transparent mb-4">
            מדיניות פרטיות
          </h1>
          <p className="text-gray-600 text-xl">
            אנו מחויבים להגנה על פרטיותכם
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-[#9a624b] to-[#ac609c] mx-auto rounded-full mt-6"></div>
        </div>

        {/* מבוא */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">מבוא</h2>
          <div className="space-y-4 text-gray-700">
            <p className="leading-relaxed">
              SHA-SHA Jewelry מחויבת להגנה על פרטיותכם. מדיניות פרטיות זו מסבירה כיצד אנו אוספים,
              משתמשים ומגנים על המידע האישי שלכם.
            </p>
            <p className="leading-relaxed">
              השימוש באתר מהווה הסכמה לאיסוף ושימוש במידע בהתאם למדיניות זו.
              אם אינכם מסכימים לתנאים אלה, אנא אל תשתמשו באתר.
            </p>
          </div>
        </div>

        {/* מידע שאנו אוספים */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">מידע שאנו אוספים</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">מידע אישי</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>שם מלא ופרטי קשר</li>
                <li>כתובת דואר אלקטרוני</li>
                <li>מספר טלפון</li>
                <li>כתובת משלוח</li>
                <li>פרטי תשלום (מאובטחים)</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">מידע טכני</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>כתובת IP</li>
                <li>סוג דפדפן ומערכת הפעלה</li>
                <li>עמודים שביקרתם</li>
                <li>זמן בילוי באתר</li>
                <li>Cookies וטכנולוגיות דומות</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">מידע על הזמנות</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>היסטוריית רכישות</li>
                <li>העדפות מוצרים</li>
                <li>סקירות וציונים</li>
                <li>תקשורת עם שירות לקוחות</li>
              </ul>
            </div>
          </div>
        </div>

        {/* כיצד אנו משתמשים במידע */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">כיצד אנו משתמשים במידע</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">עיבוד הזמנות</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>עיבוד תשלומים ומשלוחים</li>
                <li>תקשורת על סטטוס הזמנות</li>
                <li>שירות לקוחות ותמיכה</li>
                <li>החזרות והחלפות</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">שיפור השירות</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>ניתוח התנהגות משתמשים</li>
                <li>שיפור חוויית המשתמש</li>
                <li>פיתוח מוצרים חדשים</li>
                <li>אופטימיזציה של האתר</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">תקשורת</h3>
              <ul className="list-disc list-inside space-y-2">
                <li>עדכונים על הזמנות</li>
                <li>הודעות על מבצעים (בהסכמה)</li>
                <li>סקרים ומשוב</li>
                <li>תמיכה טכנית</li>
              </ul>
            </div>
          </div>
        </div>

        {/* שיתוף מידע */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">שיתוף מידע</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">שיתוף עם צדדים שלישיים</h3>
              <p className="leading-relaxed">
                אנו לא מוכרים, משכירים או משתפים את המידע האישי שלכם עם צדדים שלישיים,
                למעט במקרים הבאים:
              </p>
              <ul className="list-disc list-inside space-y-2 mt-3">
                <li>עיבוד תשלומים (באמצעות מערכות מאובטחות)</li>
                <li>שירותי משלוח (פרטי משלוח בלבד)</li>
                <li>שירותי אנליטיקה (מידע אנונימי)</li>
                <li>חובה על פי חוק</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">אבטחת מידע</h3>
              <p className="leading-relaxed">
                אנו נוקטים בכל האמצעים הנדרשים להגנה על המידע שלכם:
              </p>
              <ul className="list-disc list-inside space-y-2 mt-3">
                <li>הצפנת SSL לכל התקשורת</li>
                <li>אחסון מאובטח של נתונים</li>
                <li>גיבוי קבוע של מידע</li>
                <li>הגבלת גישה למידע רגיש</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Cookies */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Cookies</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">מה הם Cookies</h3>
              <p className="leading-relaxed">
                Cookies הם קבצים קטנים שנשמרים במכשיר שלכם ומסייעים לנו לשפר את חוויית המשתמש.
                הם מאפשרים לנו לזכור העדפות ולספק תוכן מותאם אישית.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">סוגי Cookies</h3>
              <ul className="list-disc list-inside space-y-2">
                <li><strong>Cookies חיוניים:</strong> נדרשים לפעולת האתר</li>
                <li><strong>Cookies ביצועים:</strong> עוזרים לנו להבין איך האתר משמש</li>
                <li><strong>Cookies פונקציונליים:</strong> משפרים את הפונקציונליות</li>
                <li><strong>Cookies פרסום:</strong> מציגים תוכן רלוונטי</li>
              </ul>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">ניהול Cookies</h3>
              <p className="leading-relaxed">
                ניתן לבטל או לנהל Cookies בהגדרות הדפדפן שלכם.
                שימו לב שביטול Cookies חיוניים עלול להשפיע על פעולת האתר.
              </p>
            </div>
          </div>
        </div>

        {/* זכויותיכם */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 mb-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">זכויותיכם</h2>
          <div className="space-y-6 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">זכות גישה</h3>
              <p className="leading-relaxed">
                יש לכם הזכות לבקש גישה למידע האישי שאנו מחזיקים עליכם.
                נספק לכם עותק של המידע תוך 30 ימים.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">זכות תיקון</h3>
              <p className="leading-relaxed">
                יש לכם הזכות לבקש תיקון של מידע לא מדויק או לא מעודכן.
                נעדכן את המידע בהקדם האפשרי.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">זכות מחיקה</h3>
              <p className="leading-relaxed">
                יש לכם הזכות לבקש מחיקה של המידע האישי שלכם.
                נמחק את המידע בהתאם לחוק ולצרכי העסק.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3">זכות התנגדות</h3>
              <p className="leading-relaxed">
                יש לכם הזכות להתנגד לעיבוד המידע שלכם למטרות מסוימות,
                כגון שיווק ישיר או מחקר.
              </p>
            </div>
          </div>
        </div>

        {/* יצירת קשר */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">צריכים עזרה?</h2>
          <div className="grid md:grid-cols-2 gap-8 text-gray-700">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">פרטי קשר</h3>
              <div className="space-y-3">
                <p><strong>טלפון:</strong> 053-3332127</p>
                <p><strong>אימייל:</strong> nataly@sha-sha.co.il</p>
                <p><strong>שעות פעילות:</strong> א׳-ה׳ 09:00-19:00, ו׳ 09:00-14:00</p>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-800 mb-4">מידע נוסף</h3>
              <div className="space-y-3">
                <p>• מדיניות זו נכנסה לתוקף ב-1.1.2025</p>
                <p>• עדכון אחרון: 1.1.2025</p>
                <p>• גרסה: 1.0</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage; 